import React from "react";

import { EditPenIcon } from "assets/icons";

import { ActionButton } from "./styled";

interface EditActionProps {
  disabled?: boolean;
  label?: string;
  onEnableEdit: () => void;
}
export const EditAction = (props: EditActionProps) => {
  return (
    <ActionButton
      aria-label={props.label || "Edit"}
      title={props.label || "Edit"}
      onClick={props.onEnableEdit}
      disabled={props.disabled}
    >
      <EditPenIcon />
    </ActionButton>
  );
};
